import React, { createContext, useContext, useEffect, ReactNode } from 'react';
import { useAICredit } from '@/hooks/useAICredit';
import { useAuthStore } from '@/store/auth';

interface AICreditContextType {
  checkCredit: () => Promise<boolean>;
  withCredit: <T>(action: () => Promise<T>) => Promise<T | undefined>;
  hasCredits: boolean;
  isChecking: boolean;
  availableTokens: number;
}

const AICreditContext = createContext<AICreditContextType | undefined>(undefined);

interface AICreditProviderProps {
  children: ReactNode;
}

export const AICreditProvider: React.FC<AICreditProviderProps> = ({ children }) => {
  const { user } = useAuthStore();
  const aiCredit = useAICredit();
  
  // Check credits when user changes
  useEffect(() => {
    if (user?.id) {
      aiCredit.checkCredit();
    }
  }, [user, aiCredit]);
  
  return (
    <AICreditContext.Provider value={aiCredit}>
      {children}
    </AICreditContext.Provider>
  );
};

export const useAICreditContext = (): AICreditContextType => {
  const context = useContext(AICreditContext);
  
  if (context === undefined) {
    throw new Error('useAICreditContext must be used within an AICreditProvider');
  }
  
  return context;
}; 